import { EMITTER_TYPES, getValueTypeFromEmitterType } from '@semios/app-platform-values-helpers-and-types'
import { DropdownSelectorProperty } from 'App/Map/PanelDetails/SectionTitleBars/DropdownSelectorProperty/DropdownSelectorProperty'
import type { TValuesTimeseriesProperties } from 'App/Map/types'
import { withoutPrePostFilterEmitterTypes } from 'utils/isPrePostFilterEmitterType'

const irrigationActivityValuesPrefixes = [
  'irrigationActivityIntervalsSemios_',
  'irrigationActivityPlannedIntervalsSemios_',
  'irrigationPlannedVolumeDurationSemios_',
  'irrigationVolumeDurationSemios_',
] as const

const everyPossibleIrrigationActivityTimeseriesValue = irrigationActivityValuesPrefixes.flatMap((key) =>
  withoutPrePostFilterEmitterTypes([...EMITTER_TYPES]).map((emitterType) =>
    getValueTypeFromEmitterType(key, emitterType),
  ),
)

export const IrrigationActivityDropdown = () => {
  return (
    <DropdownSelectorProperty
      valuesTimeseriesToFilterOn={
        everyPossibleIrrigationActivityTimeseriesValue as TValuesTimeseriesProperties[]
      }
    />
  )
}
